import React from 'react';
import CoinShiftNftPreview from '../../components/coinshift/NftPreview';
import Rewards from '../../components/coinshift/Rewards';
import { useGlobalState } from '../../state/GlobalStateProvider';
import EventProvider from '../events/event/EventProvider';
import MintProvider from '../events/event/mint/MintNftProvider';
import './Coinshift.scss';

const CoinshiftComponent = () => {
  const [{ user }] = useGlobalState();

  const redirect = () => {
    window.open('https://x.com/0xmercle', '_blank');
  };

  return (
    <div className='coinshift_page'>
      <div className='top_container'>
        <div className='logo'>
          <img src='https://dskhnex0aho1n.cloudfront.net/public/cs-full.png' />
        </div>
        <div className='logo_text'>
          Titan
          <div className='red'>Tigers</div>
        </div>
        <p className='powered_text'>
          powered by <img onClick={redirect} src={require('../../mercle_logo.png')} />
        </p>
        <p className='description'>
          Titan Tigers is an exclusive deal by Mercle for Coinshift’s Tiger Points program! The Tiger Points Program is a loyalty system for Coinshift Personal users, designed to
          reward engagement and provide exclusive benefits within the Coinshift ecosystem.
        </p>
        <p className='description'>
          <strong>NOTE-</strong> Titan Tigers deal is only available till 30th Oct 2024.
        </p>
        <a href='https://titantiger.notion.site/' target='_blank' className='description read_more'>
          Read all details about Titan Tiger deal and Coinshift here!{' '}
        </a>
      </div>
      <CoinShiftNftPreview />
      {user && <Rewards />}
    </div>
  );
};

const Coinshift = () => {
  return (
    <EventProvider>
      <MintProvider>
        <CoinshiftComponent />
      </MintProvider>
    </EventProvider>
  );
};

export default Coinshift;
